import { useEffect, useRef, useState } from 'react';
/**
 * @see https://stackoverflow.com/a/72319081/368691
 */
export const useMount = (effect) => {
    const ref = useRef(undefined);
    const [mounted, setMounted] = useState(false);
    const [invoked, setInvoked] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, [setMounted]);
    useEffect(() => {
        if (!mounted) {
            return () => { };
        }
        setInvoked(true);
        if (invoked) {
            return ref.current;
        }
        ref.current = effect();
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [invoked, mounted, setInvoked]);
};
//# sourceMappingURL=useMount.js.map